<div class="form-group">
    <label class="input-label">Maximum activities required</label>
    <input class="form-control"
           name="maxActivities"
           type="number"
           value="{{fieldOptions.validate.maxActivities}}"
           [(ngModel)]="fieldOptions.validate.maxActivities">
</div>